import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import InputDate from "../../../components/inputs/InputDate";
import InputNumber from "../../../components/inputs/InputNumber";
import Loader from "../../../components/layout/Loader";
import DashboardContext from "../../../Context";
import NumberFormat from 'react-number-format';

const FormsetGroup = ({ idGroup, dataArry, handelData, handelpreiod, dataUpdate }) => {

    const { authentication, urldashboard, handelerrors } = useContext(DashboardContext);


    const [dataFech, setDataFech] = useState([])

    const [Loading, setLoading] = useState(true)


    const dataFeching = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/group/getstep/${idGroup}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })

            const data = await res.data.data
            handelpreiod(data.hasPeriod)
            setDataFech(data)
            setLoading(false)
        } catch (error) {
            handelerrors(error)
        }
    }

    useEffect(() => {
        dataFeching()
    }, [idGroup])

    const handelValue = (name, value) => {

        

        dataFech.groupStepTitles.map(item => item.groupStepItem.map(sw => {
            switch (name) {
                case sw.propertyName:
                    if (sw.groupStepType === 1) {

                        if (sw.propertyName === 'startWork') {

                        }
                        else {
                            handelData({ ...dataArry, [sw.propertyName]: value })
                        }
                    }
                    else {
                        handelData({ ...dataArry, [sw.propertyName]: value ? parseInt(value) : 0 })
                    }

                    break;
                default:
                    break;
            }
        }))


    }
    return (
        <>
            {Loading ? <Loader />
                : <>

                    {dataFech.groupStepTitles.map(item => (
                        < >
                            {
                                item.groupStepItem.map((form, index) => (
                                    <Col key={index} lg='3' md='3' sm='6'>
                                        {
                                            form.groupStepType === 1 ?
                                                form.propertyName === 'startWork' ? null
                                                    :
                                                    <InputDate label={form.title} name={form.propertyName} handelValue={handelValue} />

                                                : <InputNumber label={form.title} name={form.propertyName} defaultValue={dataUpdate[form.propertyName]} handelValue={handelValue} />
                                        }
                                    </Col>))
                            }
                        </>))
                    }
                </>}
        </>
    );

}

export default FormsetGroup;
